<template>
  <div class="filters" >
    <el-form label-position="top" >
      <div class="flex-container" >
        <div v-for="(f, i) in filter" v-show="isFilterVisible(f)" :key="i" >
          <el-form-item>
            <component
              :is="f.options.type + '-filter'"
              ref="filter"
              :class="f.options.type + '-filter'"
              :data="filter[i]"
              :placeholder="api.dimension.name(f.value)"
              :disabled="f.state !== 'editable' || useGlobalFilters"
              @change="val => $emit('change', val)" />
          </el-form-item>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import * as filters from '../filter'
import customGraphApiAware from '../mixins/customGraphApiAware'

export default {
  components: {
    ...filters
  },
  mixins: [
    customGraphApiAware
  ],
  props: {
    filter: {
      type: Array,
      required: true
    },
    canEdit: {
      type: Boolean,
      required: true
    },
    useGlobalFilters: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    isFilterVisible (filter) {
      if (filter.state === 'hidden') {
        return false
      }
      return filter.state !== 'private' || this.canEdit
    },
    setFilters (useDefault) {
      return new Promise(resolve => {
        useDefault = useDefault || false
        if (typeof this.$refs.filter === 'undefined') {
          setTimeout(() => {
            this.setFilters(useDefault).then(() => resolve())
          }, 500)
        } else {
          this.$refs.filter.forEach((f, i) => {
            if (useDefault) {
              f.updateDefault()
            } else if (typeof this.filter[i].active === 'undefined') {
              f.setValues(this.filter[i].defaultValues, false)
            } else {
              f.setValues(this.filter[i].active)
            }
          })
          setTimeout(() => resolve(), 1000)
        }
      })
    }                
  }
}
</script>

<style scoped>
.range-filter {
    padding: 0 5px;
}

.filters .flex-container {
    display: flex;
    flex-basis: 150px;
    flex-wrap: wrap;
}

.filters {
    margin: 0.8em;
    margin-left: 60px;
}

.filters .flex-container > div {
    position: relative;
    margin: 0 5px;
    flex: 1;
    max-width: 200px;
    min-width: 120px;
}
</style>

<style>
.filters .el-select__tags > span {
    display: flex;
    flex-direction: column;
    width: 100%;
}
.filters .el-select__tags > span .el-tag {
    width: 100%;
    display: flex;
    align-items: center;
}
.filters .el-select__tags-text {
    max-width: 90%;
    min-width: 90%;
    overflow: hidden;
}
.filters i.el-tag__close {
    flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// node_modules/macarons-graphs-front/src/components/FiltersDisplay.vue